// Un caso en una lista para elegir (Unir casos, Agregar un correo a un caso): numero y estado, el asunto completo y
// el cliente, grupo y ultimo mensaje. No recorta el asunto.
import { type Caso, ESTADOS_CASO } from '../api/casos';
import { ago } from '../lib/format';
import { Pill } from './bits';

export function OpcionCaso({ caso: x, elegido, onElegir }: { caso: Caso; elegido: boolean; onElegir: () => void }) {
  const estado = ESTADOS_CASO.find(([v]) => v === x.estado)?.[1] ?? x.estado;
  return (
    <button type="button" className="unir-op" aria-pressed={elegido} onClick={onElegir}>
      <span className="unir-op-1">
        <span className="caso-n">#{x.numero}</span>
        <Pill tone={x.estado === 'CERRADO' || x.estado === 'RESUELTO' ? undefined : 'acc'}>{estado}</Pill>
      </span>
      <span className="unir-op-as">{x.asunto}</span>
      <span className="sb">{[x.empresa?.nombre || x.persona?.nombre || x.correoCliente, x.grupo, x.ultimoMensaje ? `último mensaje ${ago(x.ultimoMensaje)}` : ''].filter(Boolean).join(' · ')}</span>
    </button>
  );
}
